import { Loader } from '@googlemaps/js-api-loader';

const API_KEY_MAP = 'AIzaSyDiAecSzLZbZnx_Xg_PU-4oofqHDcTXK1g';

const loader = new Loader({
  apiKey: API_KEY_MAP,
  version: 'weekly',
});

const studiosLamy = { lat: 49.674470223687145, lng: 2.75945999846601 };
const origin = { lat: 48.895954, lng: 2.3621486 };

const calculateAndDisplayRoute = (directionsService, distanceMatrixService, directionsRenderer) => {
  directionsService.route({
    origin,
    destination: studiosLamy,
    avoidTolls: false,
    avoidHighways: false,
    travelMode: google.maps.TravelMode.DRIVING,
    unitSystem: google.maps.UnitSystem.METRIC,
    provideRouteAlternatives: true,
    optimizeWaypoints: true,
  })
    .then((response) => {
      directionsRenderer.setOptions({
        suppressMarkers: true,
      });
      directionsRenderer.setDirections(response);
    })
    .catch((e) => window.alert(`Directions request failed due to ${e.message}`));
};

const mapContact = () => {
  loader.load().then(() => {
    const styledMapType = new google.maps.StyledMapType(
      [
        {
          elementType: 'geometry',
          stylers: [
            {
              color: '#f5f5f5',
            },
          ],
        },
        {
          elementType: 'labels.icon',
          stylers: [
            {
              visibility: 'on',
            },
          ],
        },
        {
          elementType: 'labels.text.fill',
          stylers: [
            {
              color: '#616161',
            },
          ],
        },
        {
          elementType: 'labels.text.stroke',
          stylers: [
            {
              color: '#f5f5f5',
            },
          ],
        },
        {
          featureType: 'administrative.land_parcel',
          elementType: 'labels.text.fill',
          stylers: [
            {
              color: '#bdbdbd',
            },
          ],
        },
        {
          featureType: 'poi',
          elementType: 'geometry',
          stylers: [
            {
              color: '#eeeeee',
            },
          ],
        },
        {
          featureType: 'poi',
          elementType: 'labels.text.fill',
          stylers: [
            {
              color: '#757575',
            },
          ],
        },
        {
          featureType: 'poi.park',
          elementType: 'geometry',
          stylers: [
            {
              color: '#e5e5e5',
            },
          ],
        },
        {
          featureType: 'poi.park',
          elementType: 'labels.text.fill',
          stylers: [
            {
              color: '#9e9e9e',
            },
          ],
        },
        {
          featureType: 'road',
          elementType: 'geometry',
          stylers: [
            {
              color: '#ffffff',
            },
          ],
        },
        {
          featureType: 'road.arterial',
          elementType: 'labels.text.fill',
          stylers: [
            {
              color: '#757575',
            },
          ],
        },
        {
          featureType: 'road.highway',
          elementType: 'geometry',
          stylers: [
            {
              color: '#dadada',
            },
          ],
        },
        {
          featureType: 'road.highway',
          elementType: 'labels.text.fill',
          stylers: [
            {
              color: '#616161',
            },
          ],
        },
        {
          featureType: 'road.local',
          elementType: 'labels.text.fill',
          stylers: [
            {
              color: '#9e9e9e',
            },
          ],
        },
        {
          featureType: 'transit.line',
          elementType: 'geometry',
          stylers: [
            {
              color: '#e5e5e5',
            },
          ],
        },
        {
          featureType: 'transit.station',
          elementType: 'geometry',
          stylers: [
            {
              color: '#eeeeee',
            },
          ],
        },
        {
          featureType: 'water',
          elementType: 'geometry',
          stylers: [
            {
              color: '#c9c9c9',
            },
          ],
        },
        {
          featureType: 'water',
          elementType: 'labels.text.fill',
          stylers: [
            {
              color: '#9e9e9e',
            },
          ],
        },
        { name: 'Styled Map' },
      ],
    );

    const directionsService = new google.maps.DirectionsService();
    const distanceMatrixService = new google.maps.DistanceMatrixService();
    const directionsRenderer = new google.maps.DirectionsRenderer();

    const pointOrigin = new google.maps.LatLng(48.895954, 2.3621486);
    const pointDestination = new google.maps.LatLng(49.674470223687145, 2.75945999846601);

    const map = new google.maps.Map(document.getElementById('js-map-contact'), {
      center: studiosLamy,
      zoom: 11,
      mapTypeControlOptions: {
        mapTypeIds: ['roadmap', 'satellite', 'hybrid', 'terrain', 'styled_map'],
      },
    });
    map.mapTypes.set('styled_map', styledMapType);
    map.setMapTypeId('styled_map');

    const markerOrigin = new google.maps.Marker({
      position: pointOrigin,
      map,
      icon:'/wp-content/themes/studiolamy/dist/images/marker-dark.png'
    });

    const markerDestination = new google.maps.Marker({
      position: pointDestination,
      map,
      icon:'/wp-content/themes/studiolamy/dist/images/marker-yellow.png'
    });

    directionsRenderer.setMap(map);

    calculateAndDisplayRoute(directionsService, distanceMatrixService, directionsRenderer);
  });
};

export default mapContact;
